import { Component, HostListener, ChangeDetectionStrategy, viewChild, signal, DestroyRef } from '@angular/core';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { CookieService } from 'ngx-cookie-service';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { TraductionService } from '../../services/traduction.service';

@Component({
  selector: 'app-modale-changer-langue',
  templateUrl: './modale-changer-langue.component.html',
  styleUrls: ['./modale-changer-langue.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class ModaleChangerLangueComponent {
  modalConfirmCancel = viewChild<ModalDirective>('modalConfirmCancel');
  langueInitiale = signal<string>('');
  
  constructor(
    public bsModalRef: BsModalRef,
    private readonly traductionService: TraductionService,
    private readonly cookieService: CookieService,
    private readonly fonctionsService: FonctionsService
  ) { }

  @HostListener('window:keydown.esc', ['$event'])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
    }
    this.showModalCancel();
  }

  ngOnInit(): void {
    let langCookie = this.cookieService.get('epcLanguage');
    this.langueInitiale.set(langCookie);

    if (langCookie === 'fr')
      (<HTMLInputElement>document.getElementById('rdBtnFrancais')).checked = true;
    else if (langCookie === 'en')
      (<HTMLInputElement>document.getElementById('rdBtnAnglais')).checked = true;
    else if (langCookie === 'es')
      (<HTMLInputElement>document.getElementById('rdBtnEspagnol')).checked = true;
  }

  onSubmit() {
    this.fonctionsService.loading_screen(true);
    let langueIsoCode;
    if ((<HTMLInputElement>document.getElementById('rdBtnFrancais')).checked)
      langueIsoCode = 'fr';
    else if ((<HTMLInputElement>document.getElementById('rdBtnAnglais')).checked)
      langueIsoCode = 'en';
    else if ((<HTMLInputElement>document.getElementById('rdBtnEspagnol')).checked)
      langueIsoCode = 'es';
    
    
    if (langueIsoCode != this.langueInitiale()) {
      this.traductionService.changerLangue(langueIsoCode, true);
    }
    this.fonctionsService.loading_screen(false);
    this.bsModalRef.hide();
  }

  showModalCancel() {
    if (this.diff()) {
      this.modalConfirmCancel()?.show();
    } else {
      this.bsModalRef.hide();
    }
  }

  diff() {
    let langue;
    if ((<HTMLInputElement>document.getElementById('rdBtnFrancais')).checked)
      langue = 'fr';
    else if ((<HTMLInputElement>document.getElementById('rdBtnAnglais')).checked)
      langue = 'en';
    else if ((<HTMLInputElement>document.getElementById('rdBtnEspagnol')).checked)
      langue = 'es';

    return langue !== this.langueInitiale();
  }
}
